import { getTwigTemplate } from "../twig/twig";
import $ from "jquery";
import "stupid-table-plugin";
import NProgress from "nprogress";

let form,
  resultTable,
  resultTemplate,
  noResultTemplate,
  filters,
  reset,
  disableSearch = false;

const crisearch = () => {
  if (disableSearch) {
    return;
  }

  const data = {};

  filters.filter("[data-form-filter]").map((i, filter) => {
    data[$(filter).data("form-filter")] = $(filter).val();
  });

  NProgress.start();

  $.get("/wp-json/techcor/v1/cri/", data).done((data) => {
    if (data.length) {
      resultTable.find("tbody").html(
        data.map((item) => {
          return resultTemplate.render({ cri: item });
        })
      );
      resultTable.stupidtable_build();
    } else {
      resultTable.find("tbody").html(noResultTemplate.render());
    }

    NProgress.done();
  });
};

export default function initialize() {
  form = $("[data-form-filters]");
  filters = $("[data-form-filter]");
  reset = $("[data-form-reset]");
  resultTable = $("[data-filtered-table]");
  resultTemplate = loadResultTemplate(
    (template) => (resultTemplate = template)
  );
  noResultTemplate = loadNoResultTemplate(
    (template) => (noResultTemplate = template)
  );

  resultTable.stupidtable();

  form.on("submit", (e) => {
    e.preventDefault();
    crisearch();
  });
  filters.on("change", crisearch);

  form
    .find("select")
    .select2()
    .on("select2:open", function () {
      $(".select2-search__field").attr("placeholder", "Type to search");
    });

  reset.on("click", () => {
    setTimeout(() => {
      disableSearch = true;
      filters.trigger("change");
      disableSearch = false;
      crisearch();
    }, 100);
  });
}

function loadResultTemplate(callback) {
  return getTwigTemplate("components/cri-result.twig", callback);
}

function loadNoResultTemplate(callback) {
  return getTwigTemplate("components/cri-no-results.twig", callback);
}



// WEBPACK FOOTER //
// ./scripts/lib/search/cri.js